import { Buffer } from 'buffer';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializePWA } from './pwaUtils';

window.Buffer = window.Buffer || Buffer;


initializePWA();

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);